export const EndPoints = {
  Chats: "dispatch/chat/list",
  Rates: "dispatch/purchase-rate/list",
  SalesIntents: "dispatch/purchase-rate/list",
  CashDiscount: "masters/cash-discount/list",
  Packagings: "masters/packaging/list",
  ContractTypes: "masters/contract-type/list",
  PaymentTerms: "masters/payment-terms/list",
  ItemTypes: "masters/item-type/list",
  ItemCategories: "masters/item-category/list",
  SurveyCompanys: "masters/survey-company/list",
  Clients: "masters/clients/list",
  Millers: "masters/miller/list",
  MillersList: "masters/miller/paginated/list",
  Brokers: "masters/broker/list",
  BrokersList: "masters/broker/paginated/list",
  Transporters: "masters/transporter/list",
  TransportersList: "masters/transporter/paginated/list",
  Ports: "masters/port/list",
  PurchaseOrders: "dispatch/purchase-order/list",
  PurchaseOrdersList: "dispatch/purchase-order-paginated",
  SalesOrders: "dispatch/sales-order/list",
  Shippers: "masters/shipper/list",
  Beneficiarys: "masters/benificiary/list",
  HsNs: "masters/hsn/list",
  BrandsManagements: "masters/brand/list",
  Brands: "masters/brand/list",
  UsersAndPermissions: "users/list",
  RiceBagSellers: "masters/ricebagseller/list",
  Notifys: "masters/notify/list",
  Currencys: "masters/currency/list",
  Incoterms: "masters/inco-term/list",
  SOpaymentTerms: "masters/so-payment-term/list",
  ShippingTerms: "masters/shipping-term/list",
  Precarriers: "masters/precarrier/list",
  Policys: "masters/so-policy/list",
  Chats: "dispatch/chat/list",
  millerPayments: {
    get_bill: ({ miller_id, bill_id }) =>
      `arrival/miller-accounts/fetch-next-bill/${miller_id}${
        bill_id ? `?bill_id=${bill_id}` : ""
      }`,
    edit_bill: ({ miller_id, bill_id }) =>
      `arrival/miller-accounts/${miller_id}/bill/${bill_id}`,
    create_payment:(id)=>  `arrival/partial-payment/${id?id:"list/"}`,
    getList:()=>  `arrival/partial-payment/list/`,
    delete_payment: (id) => `arrival/partial-payment/${id}`,
  },
 brokerPayments: {
    get_bill: ({ broker_id, bill_id, brokerage_of }) =>
      `arrival/broker-accounts/fetch-next-bill/${broker_id}${
    brokerage_of && bill_id
      ? `?bill_id=${bill_id}&brokerage_of=${brokerage_of}`
      : bill_id 
        ? `?bill_id=${bill_id}` 
        : brokerage_of ? `?brokerage_of=${brokerage_of}` : ""}`,
    edit_bill: ({ broker_id, bill_id, brokerage_of }) =>
      `arrival/broker-accounts/${broker_id}/bill/${bill_id}${
   brokerage_of ? `?brokerage_of=${brokerage_of}` : ""}`,
    create_payment:(id)=>  `arrival/partial-payment/${id?id:"list/"}`,
    getList:()=>  `arrival/partial-payment/list/`
  },
  transporterPayments: {
    get_bill: ({transporter_id, bill_id }) =>
      `arrival/transporter-accounts/fetch-next-bill/${transporter_id}${
        bill_id ? `?bill_id=${bill_id}` : ""
      }`,
    edit_bill: ({transporter_id, bill_id }) =>
      `arrival/transporter-accounts//${transporter_id}/bill/${bill_id}`,
    create_payment:(id)=>  `arrival/partial-payment/${id?id:"list/"}`,
    getList:()=>  `arrival/partial-payment/list/`
  },
  DuePayments: {
    list: "arrival/due-payments/list/",
    summary: "arrival/due-payments/summary/",
    millers: "arrival/due-payments/millers/",
    brokers: "arrival/due-payments/brokers/",
  },
  Reports: {
    dashboardQuantity: "reports/dashboard/quantity/",
    dashboardBags: "reports/dashboard/bags/",
  },
};
